import Alpine from "alpinejs";

Alpine.data("tabs", (selectedId, tabs) => ({
  selectedId: "",
  tabs: [],
  init() {
    this.selectedId = selectedId || tabs[0].id;
    this.tabs = tabs;
  },
  selectTab(id) {
    if (id === this.selectedId) return;
    this.selectedId = id;
  }
}));
